import { Permission } from 'types/permission';
import { Mode } from 'types/mode';

/*
const isValidPermissions = (userPermissions: string) => {
  const permissionsFormatStructure = /^(\d+,\s?\d+,\s?\d+,\s?\d+)$/i;

  if (userPermissions) {
    let permissionsFormatMatches = userPermissions.match(permissionsFormatStructure);
    if (permissionsFormatMatches === null) {
      return false;
    }
  } else {
    return false;
  }
  return true;
};

const mapUserPermissions = (userPermissions: string) => {
  return userPermissions.split(',')
    .map((permString) => {
      return parseInt(permString, 10);
    });
};

const hasPermissionEnabled = (mode: Mode, permission: Permission, userPermissions: number[]): boolean => {
  if (permission === Permission.None) {
    return false;
  }

  const modePermission = userPermissions[mode];

  // tslint:disable:no-bitwise
  return (modePermission & permission) === permission;
};
*/

export const hasPermissionToAccessPage = (permission: Permission, userPermissions: string) => {
  return true;
  /*
  if (!isValidPermissions(userPermissions)) {
    return false;
  }

  const userPerms = mapUserPermissions(userPermissions);

  return [Mode.Create, Mode.Read, Mode.Update, Mode.Delete].some((mode: Mode): boolean => {
    return hasPermissionEnabled(mode, permission, userPerms);
  });
  */
};

export const hasPermissionTo = (modes: Mode[], permission: Permission, userPermissions: string): boolean => {
  return true;
  /* if (!isValidPermissions(userPermissions)) {
    return false;
  }

  const userPerms = mapUserPermissions(userPermissions);

  return modes.every((mode: Mode): boolean => {
    return hasPermissionEnabled(mode, permission, userPerms);
  });*/
};


// WEBPACK FOOTER //
// ./src/helpers/permission-helper.ts